/* tslint:disable */
/* eslint-disable */
/**
 * NETS(EFT) Cleaning-Service REST API
 * \"This module contains services to purge unused data and/or projects\"
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Alignment
 */
export interface Alignment {
    /**
     * 
     * @type {number}
     * @memberof Alignment
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alignment
     */
    'autoCreated'?: number;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'autoGrow'?: string;
    /**
     * 
     * @type {number}
     * @memberof Alignment
     */
    'beginningX'?: number;
    /**
     * 
     * @type {number}
     * @memberof Alignment
     */
    'beginningY'?: number;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'createdBy'?: string;
    /**
     * 
     * @type {Array<CrossSlope>}
     * @memberof Alignment
     */
    'crossSlopes'?: Array<CrossSlope>;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'entryMethod'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'increasing'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alignment
     */
    'name'?: string;
    /**
     * 
     * @type {Array<OffsetStation>}
     * @memberof Alignment
     */
    'offsetStations'?: Array<OffsetStation>;
    /**
     * 
     * @type {Array<AlignmentStation>}
     * @memberof Alignment
     */
    'stations'?: Array<AlignmentStation>;
    /**
     * 
     * @type {Survey}
     * @memberof Alignment
     */
    'survey'?: Survey;
}
/**
 * 
 * @export
 * @interface AlignmentStation
 */
export interface AlignmentStation {
    /**
     * 
     * @type {Alignment}
     * @memberof AlignmentStation
     */
    'alignment'?: Alignment;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'alignmentStationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'angle'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'angleType'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStation
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'curveType'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'curveValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'distance'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'distanceToPiStation'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStation
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStation
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStation
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface BreaklineEntity
 */
export interface BreaklineEntity {
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'breaklineJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'breaklineTypeCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'featureDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'featureName'?: string;
    /**
     * 
     * @type {number}
     * @memberof BreaklineEntity
     */
    'featureTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineEntity
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {SurfaceDef}
     * @memberof BreaklineEntity
     */
    'surfaceDef'?: SurfaceDef;
}
/**
 * 
 * @export
 * @interface CrossSlope
 */
export interface CrossSlope {
    /**
     * 
     * @type {Alignment}
     * @memberof CrossSlope
     */
    'alignment'?: Alignment;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'createdBy'?: string;
    /**
     * 
     * @type {Array<CrossSlopeStation>}
     * @memberof CrossSlope
     */
    'crossSlopeStations'?: Array<CrossSlopeStation>;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'entryMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'hiElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'offsetType'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'singleShotOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'slopeWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlope
     */
    'stationStep'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlope
     */
    'uphillsTo'?: string;
}
/**
 * 
 * @export
 * @interface CrossSlopeStation
 */
export interface CrossSlopeStation {
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStation
     */
    'createdBy'?: string;
    /**
     * 
     * @type {CrossSlope}
     * @memberof CrossSlopeStation
     */
    'crossSlope'?: CrossSlope;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStation
     */
    'crossSlopeStationOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStation
     */
    'crossSlopeStationSlope'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStation
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStation
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStation
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStation
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface EftProject
 */
export interface EftProject {
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'aoiImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'creationDate'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EftProject
     */
    'deletedFlag'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'designedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'duhName'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'jobClassId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'parentProjectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'practice'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'practices'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'projectClassId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'projectOwnerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'projectStatusDateUtc'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'projectStatusTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'projectStatusUpdatedBy'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'projectTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'projectionText'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'rdtSmoothing'?: string;
    /**
     * 
     * @type {Array<EftSession>}
     * @memberof EftProject
     */
    'sessions'?: Array<EftSession>;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'srid'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftProject
     */
    'userInputNotes'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'xMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'xMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'yMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'yMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftProject
     */
    'zUnits'?: number;
}
/**
 * 
 * @export
 * @interface EftSession
 */
export interface EftSession {
    /**
     * 
     * @type {string}
     * @memberof EftSession
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSession
     */
    'creationDate'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EftSession
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EftSession
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSession
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {EftProject}
     * @memberof EftSession
     */
    'project'?: EftProject;
    /**
     * 
     * @type {Array<EftSessionResource>}
     * @memberof EftSession
     */
    'sessionResources'?: Array<EftSessionResource>;
    /**
     * 
     * @type {string}
     * @memberof EftSession
     */
    'sessionTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSession
     */
    'sessionTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSession
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSession
     */
    'stepCodeId'?: number;
    /**
     * 
     * @type {Array<SurfaceDef>}
     * @memberof EftSession
     */
    'surfaceDefs'?: Array<SurfaceDef>;
}
/**
 * 
 * @export
 * @interface EftSessionResource
 */
export interface EftSessionResource {
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResource
     */
    'creationDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'dataSourceType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EftSessionResource
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'horizontalMeasurementUnit'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResource
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'metadata'?: string;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResource
     */
    'pixelSize'?: number;
    /**
     * 
     * @type {EftSession}
     * @memberof EftSessionResource
     */
    'session'?: EftSession;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResource
     */
    'sessionResourceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EftSessionResource
     */
    'sessionResourceTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'sessionResourceValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof EftSessionResource
     */
    'verticalMeasurementUnit'?: string;
}
/**
 * 
 * @export
 * @interface MessageObject
 */
export interface MessageObject {
    /**
     * 
     * @type {number}
     * @memberof MessageObject
     */
    'cleaningTypeCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageObject
     */
    'fileAbsolutePath'?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageObject
     */
    'gpFolderSessionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageObject
     */
    'projectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageObject
     */
    'sessionId'?: string;
}
/**
 * 
 * @export
 * @interface OffsetStation
 */
export interface OffsetStation {
    /**
     * 
     * @type {Alignment}
     * @memberof OffsetStation
     */
    'alignment'?: Alignment;
    /**
     * 
     * @type {string}
     * @memberof OffsetStation
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof OffsetStation
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof OffsetStation
     */
    'entryMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'hiElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof OffsetStation
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'offsetStationId'?: number;
    /**
     * 
     * @type {Array<OffsetStationOffset>}
     * @memberof OffsetStation
     */
    'offsetStationOffsets'?: Array<OffsetStationOffset>;
    /**
     * 
     * @type {string}
     * @memberof OffsetStation
     */
    'offsetType'?: string;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'stationStep'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'tangentAzimuth'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStation
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface OffsetStationOffset
 */
export interface OffsetStationOffset {
    /**
     * 
     * @type {string}
     * @memberof OffsetStationOffset
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof OffsetStationOffset
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof OffsetStationOffset
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationOffset
     */
    'offsetDistance'?: number;
    /**
     * 
     * @type {OffsetStation}
     * @memberof OffsetStationOffset
     */
    'offsetStation'?: OffsetStation;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationOffset
     */
    'offsetStationOffsetId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationOffset
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface SurfaceDef
 */
export interface SurfaceDef {
    /**
     * 
     * @type {string}
     * @memberof SurfaceDef
     */
    'borderJson'?: string;
    /**
     * 
     * @type {Array<BreaklineEntity>}
     * @memberof SurfaceDef
     */
    'breaklines'?: Array<BreaklineEntity>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDef
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'creationDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'deleted'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDef
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {EftSession}
     * @memberof SurfaceDef
     */
    'session'?: EftSession;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'srid'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'surfaceDefClassId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDef
     */
    'surfaceDefTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'surfaceDefTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDef
     */
    'surfaceJson'?: string;
    /**
     * 
     * @type {Array<Survey>}
     * @memberof SurfaceDef
     */
    'surveys'?: Array<Survey>;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'xMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'xMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'yMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'yMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDef
     */
    'zUnits'?: number;
}
/**
 * 
 * @export
 * @interface Survey
 */
export interface Survey {
    /**
     * 
     * @type {Array<Alignment>}
     * @memberof Survey
     */
    'alignments'?: Array<Alignment>;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof Survey
     */
    'creationDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof Survey
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof Survey
     */
    'numberOfGroundPoints'?: number;
    /**
     * 
     * @type {SurfaceDef}
     * @memberof Survey
     */
    'surfaceDef'?: SurfaceDef;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'surveyCoordinateSystem'?: string;
    /**
     * 
     * @type {Array<SurveyFeature>}
     * @memberof Survey
     */
    'surveyFeatures'?: Array<SurveyFeature>;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'surveyName'?: string;
    /**
     * 
     * @type {number}
     * @memberof Survey
     */
    'surveyTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'surveyUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Survey
     */
    'surveyorInformation'?: string;
}
/**
 * 
 * @export
 * @interface SurveyFeature
 */
export interface SurveyFeature {
    /**
     * 
     * @type {string}
     * @memberof SurveyFeature
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyFeature
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyFeature
     */
    'featureDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'featureTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyFeature
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyFeature
     */
    'pointName'?: string;
    /**
     * 
     * @type {Survey}
     * @memberof SurveyFeature
     */
    'survey'?: Survey;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'tinable'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'visible'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyFeature
     */
    'z'?: number;
}

/**
 * HealthCheckControllerApi - axios parameter creator
 * @export
 */
export const HealthCheckControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseSvcUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthcheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthCheckControllerApi - functional programming interface
 * @export
 */
export const HealthCheckControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthCheckControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseSvcUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseSvcUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthCheckControllerApi - factory interface
 * @export
 */
export const HealthCheckControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthCheckControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseSvcUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.baseSvcUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthCheckControllerApi - object-oriented interface
 * @export
 * @class HealthCheckControllerApi
 * @extends {BaseAPI}
 */
export class HealthCheckControllerApi extends BaseAPI {
    /**
     * 
     * @summary baseSvc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckControllerApi
     */
    public baseSvcUsingGET(options?: AxiosRequestConfig) {
        return HealthCheckControllerApiFp(this.configuration).baseSvcUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MonitoringControllerApi - axios parameter creator
 * @export
 */
export const MonitoringControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck2UsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitoring/healthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MonitoringControllerApi - functional programming interface
 * @export
 */
export const MonitoringControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MonitoringControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheck2UsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheck2UsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MonitoringControllerApi - factory interface
 * @export
 */
export const MonitoringControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MonitoringControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck2UsingGET(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.healthCheck2UsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MonitoringControllerApi - object-oriented interface
 * @export
 * @class MonitoringControllerApi
 * @extends {BaseAPI}
 */
export class MonitoringControllerApi extends BaseAPI {
    /**
     * 
     * @summary healthCheck2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringControllerApi
     */
    public healthCheck2UsingGET(options?: AxiosRequestConfig) {
        return MonitoringControllerApiFp(this.configuration).healthCheck2UsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProjectCleanupControllerApi - axios parameter creator
 * @export
 */
export const ProjectCleanupControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getAllProjects
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary performHydroProjectCleanup
         * @param {string} projectUUID projectUUID
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performHydroProjectCleanupUsingGET: async (projectUUID: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUUID' is not null or undefined
            assertParamExists('performHydroProjectCleanupUsingGET', 'projectUUID', projectUUID)
            const localVarPath = `/cleanUpHydroProject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (projectUUID !== undefined) {
                localVarQueryParameter['projectUUID'] = projectUUID;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary performProjectCleanup2
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performProjectCleanup2UsingGET: async (uuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('performProjectCleanup2UsingGET', 'uuid', uuid)
            const localVarPath = `/cleanupProjects2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary performProjectCleanup
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performProjectCleanupUsingGET: async (uuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('performProjectCleanupUsingGET', 'uuid', uuid)
            const localVarPath = `/cleanupProjects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary testCleaningService
         * @param {MessageObject} message message
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCleaningServiceUsingPOST: async (message: MessageObject, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'message' is not null or undefined
            assertParamExists('testCleaningServiceUsingPOST', 'message', message)
            const localVarPath = `/clean`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(message, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectCleanupControllerApi - functional programming interface
 * @export
 */
export const ProjectCleanupControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectCleanupControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getAllProjects
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProjectsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EftProject>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProjectsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary performHydroProjectCleanup
         * @param {string} projectUUID projectUUID
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async performHydroProjectCleanupUsingGET(projectUUID: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.performHydroProjectCleanupUsingGET(projectUUID, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary performProjectCleanup2
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async performProjectCleanup2UsingGET(uuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.performProjectCleanup2UsingGET(uuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary performProjectCleanup
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async performProjectCleanupUsingGET(uuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.performProjectCleanupUsingGET(uuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary testCleaningService
         * @param {MessageObject} message message
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testCleaningServiceUsingPOST(message: MessageObject, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testCleaningServiceUsingPOST(message, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectCleanupControllerApi - factory interface
 * @export
 */
export const ProjectCleanupControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectCleanupControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getAllProjects
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProjectsUsingGET(authorization?: string, options?: any): AxiosPromise<Array<EftProject>> {
            return localVarFp.getAllProjectsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary performHydroProjectCleanup
         * @param {string} projectUUID projectUUID
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performHydroProjectCleanupUsingGET(projectUUID: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.performHydroProjectCleanupUsingGET(projectUUID, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary performProjectCleanup2
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performProjectCleanup2UsingGET(uuid: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.performProjectCleanup2UsingGET(uuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary performProjectCleanup
         * @param {string} uuid uuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performProjectCleanupUsingGET(uuid: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.performProjectCleanupUsingGET(uuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary testCleaningService
         * @param {MessageObject} message message
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testCleaningServiceUsingPOST(message: MessageObject, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.testCleaningServiceUsingPOST(message, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectCleanupControllerApi - object-oriented interface
 * @export
 * @class ProjectCleanupControllerApi
 * @extends {BaseAPI}
 */
export class ProjectCleanupControllerApi extends BaseAPI {
    /**
     * 
     * @summary getAllProjects
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectCleanupControllerApi
     */
    public getAllProjectsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ProjectCleanupControllerApiFp(this.configuration).getAllProjectsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary performHydroProjectCleanup
     * @param {string} projectUUID projectUUID
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectCleanupControllerApi
     */
    public performHydroProjectCleanupUsingGET(projectUUID: string, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectCleanupControllerApiFp(this.configuration).performHydroProjectCleanupUsingGET(projectUUID, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary performProjectCleanup2
     * @param {string} uuid uuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectCleanupControllerApi
     */
    public performProjectCleanup2UsingGET(uuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectCleanupControllerApiFp(this.configuration).performProjectCleanup2UsingGET(uuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary performProjectCleanup
     * @param {string} uuid uuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectCleanupControllerApi
     */
    public performProjectCleanupUsingGET(uuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectCleanupControllerApiFp(this.configuration).performProjectCleanupUsingGET(uuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary testCleaningService
     * @param {MessageObject} message message
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectCleanupControllerApi
     */
    public testCleaningServiceUsingPOST(message: MessageObject, authorization?: string, options?: AxiosRequestConfig) {
        return ProjectCleanupControllerApiFp(this.configuration).testCleaningServiceUsingPOST(message, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ServiceStatusControllerApi - axios parameter creator
 * @export
 */
export const ServiceStatusControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/entityCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/healthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckCoreUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/manifestCheck_core`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/manifestCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/profileCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceStatusControllerApi - functional programming interface
 * @export
 */
export const ServiceStatusControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceStatusControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entityCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entityCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manifestCheckCoreUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manifestCheckCoreUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manifestCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manifestCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceStatusControllerApi - factory interface
 * @export
 */
export const ServiceStatusControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceStatusControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.entityCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.healthCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckCoreUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.manifestCheckCoreUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.manifestCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.profileCheckUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceStatusControllerApi - object-oriented interface
 * @export
 * @class ServiceStatusControllerApi
 * @extends {BaseAPI}
 */
export class ServiceStatusControllerApi extends BaseAPI {
    /**
     * 
     * @summary entityCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public entityCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).entityCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary healthCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public healthCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).healthCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary manifestCheck_core
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public manifestCheckCoreUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).manifestCheckCoreUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary manifestCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public manifestCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).manifestCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary profileCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public profileCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).profileCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


